module.exports = __webpack_public_path__ + "ics-c7f6ee5eacc4402f61ff01728810167f.svg";


//////////////////
// WEBPACK FOOTER
// ./Resources/public/static-src/images/file-formats/ics.svg
// module id = 41
// module chunks = 0